var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"opacity":1,"value":_vm.show}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#fff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }